import { Dialog } from "@mui/material";
import { ReactNode } from "react";
import styled from "styled-components";
import theme from "../../theme";
import { XButton } from "../../assets/icons/icons";
import { useWindowSize } from "@reactuses/core";

const { md } = theme.screen;

type Prop = {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  width: string;
  contentsOverflow?: "auto" | "hidden" | "visible";
  fullScreen?: boolean;
  pt?: string;
  pb?: string;
  backgroundColor?: string;
};
export const ModalLayout = ({
  open,
  onClose,
  title,
  children,
  width,
  contentsOverflow,
  fullScreen,
  pt = "70px",
  pb,
  backgroundColor,
}: Prop) => {
  const { width: windowWidth } = useWindowSize();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          maxWidth: `calc(${width} + 40px)`,
          borderRadius: fullScreen ? "0px" : "20px",
          pt: pt,
          pb: pb ? pb : windowWidth <= md ? "20px" : "70px",
          overflow: "hidden",
          backgroundColor: backgroundColor
            ? backgroundColor
            : theme.color.white,
        },
      }}
      fullScreen={fullScreen}
    >
      <ButtonContainer style={{ height: pt }}>
        <XButton onClick={onClose} />
      </ButtonContainer>
      <Title>{title}</Title>

      <Contents
        style={{
          overflowY: contentsOverflow ? contentsOverflow : "auto",
          margin: fullScreen ? "0px" : `0 20px`,
          height: "100%",
        }}
      >
        {children}
      </Contents>
    </Dialog>
  );
};

const Title = styled.h1`
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: ${theme.color.neutral_500};
  position: absolute;
  top: 25px;
  left: 25px;
`;

const Contents = styled.div``;

const ButtonContainer = styled.div`
  position: absolute;
  top: 0;
  right: 10px;
  color: ${theme.color.neutral_400};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;

  @media (max-width: ${md}px) {
    svg {
      width: 25px;
      height: 25px;
    }
  }
`;
